import PropTypes from "prop-types";
import { createContext, useState } from "react";
import useUser from "../../../core/hooks/use-user";
import { useEffect } from "react";

const SelectsFiltrosCuadrosTurnosContext = createContext({});

export function SelectsFiltrosCuadrosTurnosProvider({ children }) {
    const { getUserData } = useUser();
    const user = getUserData();
    const [areaId, setAreaId] = useState(null);
    const [subAreas, setSubAreas] = useState([]);
    const [turnos, setTurnos] = useState([]);

    useEffect(() => {
        if (user.sedes_areas.length < 2) {
            setAreaId(user.sedes_areas[0].area.id);
        }
    }, []);

    const actualizarArea = async (areaId) => {
        setAreaId(areaId);
    };

    return (
        <SelectsFiltrosCuadrosTurnosContext.Provider
            value={{
                areaId,
                actualizarArea,
                subAreas,
                setSubAreas,
                turnos,
                setTurnos,
            }}
        >
            {children}
        </SelectsFiltrosCuadrosTurnosContext.Provider>
    );
}

SelectsFiltrosCuadrosTurnosProvider.propTypes = {
    children: PropTypes.element,
};

export default SelectsFiltrosCuadrosTurnosContext;
